<template>
  <v-dialog v-if="dOpenComponente" v-model="dLoading" hide-overlay persistent width="300">
    <v-card class="datModalTitleContainer" dark>
      <v-card-text>
        {{$t(dNombre)}}
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'ScreenLoading',
    data () {
      return {
        dNombre: '',
        dOpenComponente: false,
        dLoading: true
      }
    },
    created () {},
    mounted () {},
    methods: {
      fTriggerDialog (textLoad) {
        this.dNombre = (textLoad) || 'cargandoContenido'
        this.dOpenComponente = !this.dOpenComponente
      },
      fCloseDialog() {
        this.dOpenComponente = false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Generales/ScreenLoading.vue